import { sortArrayBasedOnAnotherArray } from "core-web/utils/sorting";

const getCurrentCategoryInNavigation = (navigation = [], currentCategoryId) => {
    if (!navigation) {
        return null;
    }

    let currentCategory;
    navigation.forEach((category) => {
        if (!category) {
            return;
        }
        if (parseInt(category.link.link_id, 10) === parseInt(currentCategoryId, 10)) {
            currentCategory = category;
        } else if (!currentCategory) {
            currentCategory = getCurrentCategoryInNavigation(
                (category.top_links || []).concat(category.links),
                currentCategoryId,
            );
        }
    });

    return currentCategory;
};

export const sortCategoriesByNavigation = (categories, navigation, currentCategoryId) => {
    const currentLevel = getCurrentCategoryInNavigation(navigation, currentCategoryId);
    const clonedCategories = JSON.parse(JSON.stringify(categories));

    if (!currentLevel || !currentLevel?.links?.length) {
        return categories;
    }

    const navigationLinkIds = (currentLevel.top_links || [])
        .concat(currentLevel.links || [])
        .map(({ link }) => parseInt(link.link_id, 10));

    return sortArrayBasedOnAnotherArray(clonedCategories, navigationLinkIds, "id");
};
